export default function OverviewSection() {
  const items = [
    { icon: "ri-user-follow-line", label: "Staff activity" },
    { icon: "ri-task-line", label: "Tasks" },
    { icon: "ri-line-chart-line", label: "Performance" },
    { icon: "ri-money-dollar-circle-line", label: "Revenue" },
    { icon: "ri-alarm-warning-line", label: "Alerts" },
    { icon: "ri-checkbox-circle-line", label: "Approvals" },
  ];

  return (
    <section className="relative py-16 md:py-24 bg-graphite-850">
      <div className="absolute inset-0 grid-pattern opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-emerald-accent/[0.02] to-transparent" />
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <div className="glass-card p-2 md:p-3 rounded-xl overflow-hidden">
                <img
                  alt="God's Eye Business Overview Dashboard"
                  className="w-full rounded-lg object-cover"
                  src="https://public.readdy.ai/ai/img_res/ae4f6ab95f2959a2dcea22a9e67a62bb.jpg"
                />
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
                See the Business Clearly. <span className="text-emerald-accent">Act Faster.</span>
              </h2>
              <p className="text-base md:text-lg text-silver-300 leading-relaxed mb-8">
                StackMap gives leadership the complete operational picture, not in weeks, but in real time. Know what your people are doing, where tasks stand, how revenue is tracking, and what needs your attention now.
              </p>
              <div className="grid grid-cols-2 gap-3">
                {items.map((item) => (
                  <div key={item.label} className="flex items-center gap-2.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${item.icon} text-emerald-accent text-sm`} />
                    </span>
                    <span className="text-sm font-medium text-silver-200">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}